export default {"src":"/_next/static/media/CallFill.89f6aff4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};